module.exports = __webpack_public_path__ + "static/media/IMG-29.039a141d.jpg";